module.exports = __webpack_public_path__ + "static/media/Fashion-store-587411.38623109.jpg";